import Vue from 'vue'
import Vuex from 'vuex'
import authen from './core/authen'
import dashboard from './dashboard'
import spotlight from './spotlight'
import membermanager from './membermanager'
import insightsManagers from './insights-managers'
import monthlyInsignhts from './monthly-insignhts'
import monthlyEngaged from './monthly-engaged'
import monthlyStrength from './monthly-strength'
import quarterlyInsignhts from './quarterly-insignhts'
import quarterlyEngaged from './quarterly-engaged'
import quarterlyStrength from './quarterly-strength'
import newmember from './newmember'
import team from './team'
import report from './report'
import peerFeedback from './peer-feedback'
import verifyemailreport from './verify-email-report'
import companyHealthStatus from './company-health-status'
import performanceSummaryReport from './performance-summary-report'
import highPerformingManagers from './high-performing-managers'
Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
      authen,
      dashboard,
      spotlight,
      membermanager,
      insightsManagers,
      monthlyInsignhts,
      monthlyEngaged,
      monthlyStrength,
      quarterlyInsignhts,
      quarterlyEngaged,
      quarterlyStrength,
      newmember,
      team,
      report,
      verifyemailreport,
      peerFeedback,
      companyHealthStatus,
      performanceSummaryReport,
      highPerformingManagers
  }
})

